var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list-item",
    {
      class: { "has-variations": _vm.ordine.numeroVariazioniNonRilevate > 0 },
      attrs: { "two-line": "" },
      on: {
        click: function ($event) {
          return _vm.showDetail(_vm.ordine)
        },
      },
    },
    [
      _c(
        "v-list-item-avatar",
        [
          _c(
            "v-icon",
            {
              class: [
                _vm.iconClassByStatus(_vm.ordine),
                "lighten-1",
                "white--text",
              ],
            },
            [_vm._v(_vm._s(_vm._f("statoOrdineMTMIco")(_vm.ordine.stato)))]
          ),
        ],
        1
      ),
      _c(
        "v-list-item-content",
        [
          _c("v-list-item-title", [
            _vm._v("Numero Ordine: "),
            _c("strong", [_vm._v(_vm._s(_vm.ordine.id))]),
            _vm._v(", Data Consegna: "),
            _c("strong", [
              _vm._v(_vm._s(_vm._f("formatDate")(_vm.ordine.dataConsegna))),
            ]),
            _vm._v(", Priorità: "),
            _c("strong", [_vm._v(_vm._s(_vm.ordine.priorita))]),
          ]),
          _c("v-list-item-subtitle", [
            _vm._v("Cliente: "),
            _c("strong", [_vm._v(_vm._s(_vm.ordine.nominativoCliente))]),
            _vm._v(
              ", ID Cliente : " +
                _vm._s(_vm.ordine.idCliente) +
                ", Codice zona: " +
                _vm._s(_vm.ordine.codiceZona) +
                ", Numero righe: " +
                _vm._s(_vm.ordine.numeroRighe) +
                ", Numero misure: " +
                _vm._s(_vm.ordine.numeroMisure) +
                ", Numero misure cliente: " +
                _vm._s(_vm.ordine.numeroMisureCliente) +
                ", Allegati: " +
                _vm._s(_vm.ordine.numeroAllegati) +
                ", Allegati Cliente: " +
                _vm._s(_vm.ordine.numeroAllegatiCliente) +
                " "
            ),
          ]),
          _vm.ordine.numeroVariazioniNonRilevate == 1
            ? _c(
                "v-list-item-subtitle",
                { staticStyle: { color: "#3f8fd0" } },
                [
                  _vm._v("É presente "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.ordine.numeroVariazioniNonRilevate)),
                  ]),
                  _vm._v(" variazione non rilevata."),
                ]
              )
            : _vm._e(),
          _vm.ordine.numeroVariazioniNonRilevate > 1
            ? _c(
                "v-list-item-subtitle",
                { staticStyle: { color: "#3f8fd0" } },
                [
                  _vm._v("Sono presenti "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.ordine.numeroVariazioniNonRilevate)),
                  ]),
                  _vm._v(" variazioni non rilevate."),
                ]
              )
            : _vm._e(),
          _vm.ordine.numeroRigheMTMDatiOrdineFornitoreInviati == 1
            ? _c(
                "v-list-item-subtitle",
                { staticStyle: { color: "#855b5b" } },
                [
                  _c("strong", [
                    _vm._v(
                      "É PRESENTE " +
                        _vm._s(
                          _vm.ordine.numeroRigheMTMDatiOrdineFornitoreInviati
                        ) +
                        " RIGA MTM SU " +
                        _vm._s(_vm.ordine.numeroRighe) +
                        " DELLA QUALE NON SONO STATI INVIATI I DATI FORNITORE"
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.ordine.numeroRigheMTMDatiOrdineFornitoreInviati > 1
            ? _c(
                "v-list-item-subtitle",
                { staticStyle: { color: "#855b5b" } },
                [
                  _c("strong", [
                    _vm._v(
                      "SONO PRESENTI " +
                        _vm._s(
                          _vm.ordine.numeroRigheMTMDatiOrdineFornitoreInviati
                        ) +
                        " RIGHE MTM SU " +
                        _vm._s(_vm.ordine.numeroRighe) +
                        " DELLE QUALI NON SONO STATI INVIATI I DATI FORNITORE"
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { style: { padding: "0", width: "25%" } },
        [
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "flex-direction": "row",
                  "flex-wrap": "wrap",
                  "padding-bottom": "24px",
                },
              },
              _vm._l(_vm.ordine.allegatiOrdine, function (allegatoOrdine) {
                return _c(
                  "v-btn",
                  {
                    key: allegatoOrdine.idAllegato,
                    staticStyle: {
                      color: "white",
                      "margin-top": "10px",
                      "margin-left": "10px",
                    },
                    attrs: {
                      loading: _vm.buttonDownloadIsLoading(
                        allegatoOrdine.idAllegato
                      ),
                      color: "green lighten-2",
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.downloadAllegato(
                          allegatoOrdine.idAllegato,
                          allegatoOrdine.nomeFile,
                          _vm.ordine.fornitore
                        )
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          "text-overflow": "ellipsis",
                          "white-space": "nowrap",
                        },
                        attrs: { title: allegatoOrdine.nomeFile },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.getStringBeforeUnderscore(
                              allegatoOrdine.nomeFile
                            )
                          )
                        ),
                      ]
                    ),
                    _c("v-icon", { attrs: { right: "" } }, [
                      _vm._v("mdi-download"),
                    ]),
                  ],
                  1
                )
              }),
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }